import { useOrganizationBusinessUnits } from '@airship-platform/airship-proposal';
import { FlexBox } from '@airship-platform/jam-web/components';
import { OfficeBuildingIcon } from '@airship-platform/jam-web/icons';
import Typography from '@mui/material/Typography';

interface BusinessUnitNameProps {
  businessUnitId?: string;
}

const BusinessUnitName: React.FC<BusinessUnitNameProps> = ({
  businessUnitId,
}) => {
  const { businessUnits } = useOrganizationBusinessUnits();

  if (!businessUnitId) {
    return null;
  }

  const businessUnit = businessUnits.find(
    (unit) => unit.organizationBusinessUnitId === businessUnitId
  );

  if (!businessUnit) {
    return null;
  }

  return (
    <FlexBox gap={1} alignItems={'flex-start'}>
      <OfficeBuildingIcon />
      <Typography variant="body2">
        Business Unit: {businessUnit.name}
      </Typography>
    </FlexBox>
  );
};

export default BusinessUnitName;
